import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { Link } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import {fetchCodex, fetchCodexItem, updateCodex} from '../redux/actions';
import { userSelector, codexSelector, rankSelector, authSelector } from '../redux/selectors'
import CodexDetail from './CodexDetail';
import { toArray } from '../common/util';
import CodexItem from "./CodexItem";
import {hasPermission} from "../common/permissions";

class Codex extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate= this.handleUpdate.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | Codex";
        if (this.props.match.params.id) {
            this.props.getCodex(); // this populates the parent dropdown
            this.props.getCodexItem(this.props.match.params.id);
            
        }
    }

    handleUpdate() {
        if (!this.props.codex.pending && this.props.codex.more) {
            this.props.getCodex();
        }
    }

    render() {
        const codexItems = toArray(this.props.codex.data)
            .filter(codex => codex.parent === null)
            .sort((a, b) => a.order - b.order)
            .map((codex) => (
            <div className="panel-adt" key={`${codex.id}-codex`}>
                <CodexItem page={codex} codex={this.props.codex.data}/>
            </div>
        ));
        if (!this.props.match.params.id) {
            return (
                <div>
                    {(hasPermission('publications.add_codex', this.props.auth.permissions)) ? (
                        <Link to="/codex/create"><Button className="pull-right"><FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth /> Add a page</Button></Link>
                    ) : null
                    }
                    <h1>Codex</h1>
                    <FlipMove
                        staggerDelayBy={50}
                        appearAnimation="fade"
                        enterAnimation="fade"
                        leaveAnimation="fade"
                        className="codex"
                    >
                        {codexItems}
                    </FlipMove>
                    <div>
                        <Waypoint
                            key="waypoint"
                            onEnter={this.handleUpdate}
                            bottomOffset='-10%'
                        />
                    </div>
                </div>
            )
        } else {
            const codexDetail = toArray(this.props.codex.data)
                .filter(codex => codex.slug === this.props.match.params.id)
                .map((codex) => (
                    <CodexDetail key={`${codex.id}-codexdetail`} auth={this.props.auth} page={codex} users={this.props.users} ranks={this.props.ranks} codex={this.props.codex} editCodex={this.props.editCodex} />
                ));
            return <div>{codexDetail}</div>
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    codex: codexSelector(state),
    ranks: rankSelector(state),
    users: userSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getCodex: () => dispatch(fetchCodex()),
    getCodexItem: (slug) => dispatch(fetchCodexItem(slug)),
    editCodex: (codex, values) => dispatch(updateCodex(codex, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Codex);


// WEBPACK FOOTER //
// ./src/Media/Codex.js